














import { createComponent } from "@vue/composition-api";
import { findGetters as findScoreGetters } from "@dcc/store/score/getters";
import { getActions as getScoreActions } from "@dcc/store/score/actions";
import DrinkerResults from "@dcc/components/DrinkerResults.vue";
import { BasePrimaryButton } from "@web-components";

import { getRiskText } from "@dcc/constants/riskLevels";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { SHOW_TIPS_LINK } from "@dcc/constants/links";

export default createComponent({
  components: {
    BasePrimaryButton,
    DrinkerResults
  },
  setup(props: {}, context) {
    const { getRiskLevel, getIsBingeDrinker } = findScoreGetters(
      context.root.$store
    );
    const riskLevel = getRiskLevel();
    const dictionary = useDictionary();

    const isBingeDrinker = getIsBingeDrinker();

    const { trackShowMeTipsClicked } = getScoreActions(context.root.$store);

    const { monthlyRiskTipsTitle, monthlyRiskTipsDescription } = getRiskText(
      isBingeDrinker.value
    );

    const handleShowMeTips = () => {
      trackShowMeTipsClicked();
    };
    return {
      riskLevel,
      monthlyRiskTipsTitle,
      monthlyRiskTipsDescription,
      handleShowMeTips,
      ...dictionary,
      SHOW_TIPS_LINK
    };
  }
});
